import { MatProgressBar } from '@angular/material/progress-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../shared/services/data.service';
import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'xp-auth',
    templateUrl: './auth.component.html',
    styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private dataservice: DataService,
        private authService: AuthService,
        @Inject("BASE_URL") baseurl: string
    ) {
        // check if route has authcode in the query parameters
        if (route.snapshot.queryParams.code) {
            // if the authcode is present then get access token.
            this.authService.getAccessToken(encodeURIComponent(route.snapshot.queryParams.code)).then(
                (data: any) => {
                    //set access token to session storage.

                    // verify access token is available or not.
                    let token = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
                    if (token) {
                        //refresh timer to the new expiry time of the token
                        this.refreshTimer();

                        //navigate to home page (successful authentication).
                        this.navigateToRoute();
                    }
                }
            )
        }
        else {
            // if authcode is not there then check for accesstoken
            let accessToken = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
            if (accessToken) {
                //check if accestoken is expired if yes then redirect to auth.
                if (accessToken && this.isTokenExpired(accessToken)) {
                    window.location.href = `${baseurl}api/auth/redirect-auth`;
                }

                //check if accestoken is abput to expire if yes then get new token using refresh token
                if (accessToken && this.isTokenAboutToExpire(accessToken)) {
                    let refreshToken = sessionStorage.getItem(environment.REFRESH_TOKEN_KEY);
                    this.authService.getRefreshToken(refreshToken);
                }
            }
            else {
                // if accesstoken is not there in session storage then redirect to auth.
                window.location.href = `${baseurl}api/auth/redirect-auth`;
            }
        }
    }

    refreshTimer() {
        setTimeout(() => {
            let token = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);

            if (token) {
                //convert expiry time to date and time.
                var expiry = new Date(this.parseJWT(token).exp * 1000)

                //check if token about to expire (less than 5 min are left to expire)
                if ((expiry.getTime() - 5 * 60 * 1000) <= new Date().getTime()) {
                    //if token about to expire call for refresh token.
                    let refreshToken = sessionStorage.getItem(environment.REFRESH_TOKEN_KEY);

                    this.authService.getRefreshToken(refreshToken).then(
                        (data) => {
                        }
                    );
                }
            }
        }, 120000);
    }

    private parseJWT(token: string): any {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse(atob(base64));
        } catch (error) {
            return null
        }
    }

    private navigateToRoute() {
        const type = sessionStorage.getItem("type")?.toLowerCase();
        const matterId = sessionStorage.getItem("matterId");
        const actionStepOrgKey = sessionStorage.getItem("actionStepOrgKey");

        if (type === "conflictcheck") {
            if (matterId && actionStepOrgKey) {
                this.router.navigate([`/conflictcheck/${matterId}/${actionStepOrgKey}`]);
            } else {
                this.router.navigate(['/conflictcheck']);
            }
        }
        else if (type === "idverification") {
            if (matterId && actionStepOrgKey) {
                this.router.navigate([`/idverification/${matterId}/${actionStepOrgKey}`]);
            } else {
                this.router.navigate(['/idverification']);
            }
        }
        else {
            this.router.navigate(['/home']);
        }
    }



    private isTokenExpired(accessToken: string) {
        let tokenExpiryDateTime = new Date(this.parseJWT(accessToken).exp * 1000);
        return tokenExpiryDateTime < new Date();
    }

    private isTokenAboutToExpire(accessToken: string) {
        let tokenExpiryDateTime = new Date(this.parseJWT(accessToken).exp * 1000);
        let tokenExpiryDateTimeMinusFiveMins = new Date(this.parseJWT(accessToken).exp - 5 * 60 * 1000);

        return (new Date() >= tokenExpiryDateTimeMinusFiveMins) && (new Date() < tokenExpiryDateTime)
    }

    ngOnInit(): void {
    }
}
